import React from 'react';
import dayjs from 'utils/dayjs-timezone';
import { Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Heading, Link, } from '@spothero/ui';
import useConfig from 'hooks/use-config';
import FacilityUtils from 'utils/facility-utils';
const SpotDetailsAccordion = ({ cancellationAllowed, }) => {
    const { siteUrl } = useConfig();
    const startTime = dayjs
        .tz('2022-07-29 6:00', 'America/Chicago')
        .tz(dayjs.tz.guess())
        .format('ha');
    const endTime = dayjs
        .tz('2022-07-29 23:00', 'America/Chicago')
        .tz(dayjs.tz.guess())
        .format('ha z');
    return (<Accordion allowToggle marginX={4}>
            {cancellationAllowed &&
            cancellationAllowed !==
                FacilityUtils.CANCELLATION_ALLOWED_ENUM.NOT_ALLOWED && (<AccordionItem>
                        <Heading as="h3">
                            <AccordionButton paddingX={0} paddingY={4}>
                                <Text fontFamily="body" fontSize="sm" flex="1" textAlign="left" fontWeight="normal">
                                    Free Cancellation Policy
                                </Text>
                                <AccordionIcon />
                            </AccordionButton>
                        </Heading>
                        <AccordionPanel paddingX={0} paddingTop={0} paddingBottom={4}>
                            <Text as="p" fontSize="sm" marginBottom={4}>
                                At this facility, you have up until the minute
                                your reservation begins to cancel your parking
                                for a full refund. You can cancel your
                                reservation on the SpotHero website or app.
                            </Text>
                            <Text as="p" fontSize="sm" marginBottom={4}>
                                If you&apos;re having trouble with your
                                reservation and it&apos;s after the start time,
                                please reach out to our Customer Heroes who are
                                more than happy to help rectify any situation!
                            </Text>
                        </AccordionPanel>
                    </AccordionItem>)}
            <AccordionItem>
                <Heading as="h3">
                    <AccordionButton paddingX={0} paddingY={4}>
                        <Text fontFamily="body" fontSize="sm" flex="1" textAlign="left" fontWeight="normal">
                            365-Day Customer Support
                        </Text>
                        <AccordionIcon />
                    </AccordionButton>
                </Heading>
                <AccordionPanel paddingX={0} paddingTop={0} paddingBottom={4}>
                    <Text as="p" fontSize="sm" marginBottom={4}>
                        SpotHero has your back. If you have any issues while
                        parking, please call our Customer Heroes immediately at{' '}
                        <Link href={`tel:8443247768`}>844-324-SPOT (7768)</Link>
                        . We&apos;re here 365 days a year, {startTime} &#45;{' '}
                        {endTime}
                    </Text>
                    <Text as="p" fontSize="sm" marginBottom={4}>
                        For non-urgent issues shoot us an email at{' '}
                        <Link href="mailto:support@spothero.com">
                            support@spothero.com
                        </Link>
                        . We&apos;ll get back you within 24 hours.
                    </Text>
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <Heading as="h3">
                    <AccordionButton paddingX={0} paddingY={4}>
                        <Text fontFamily="body" fontSize="sm" flex="1" textAlign="left" fontWeight="normal">
                            Guaranteed parking by SpotHero
                        </Text>
                        <AccordionIcon />
                    </AccordionButton>
                </Heading>
                <AccordionPanel paddingX={0} paddingTop={0} paddingBottom={4}>
                    <Text as="p" fontSize="sm" marginBottom={4}>
                        When you pay with SpotHero, we guarantee you will have a
                        spot to park in, at the price you paid, or your money
                        back.
                    </Text>
                    <Text as="p" fontSize="sm" marginBottom={4}>
                        If a parking facility is ever full when you arrive, call
                        us immediately! We&apos;ll rebook your parking at the
                        closest available nearby facility at no extra charge, or
                        give you a full refund. We&apos;ll also reach out to our
                        partner to prevent this from happening again.
                    </Text>
                    <Text as="p" fontSize="sm" marginBottom={4}>
                        For specifics, please refer to the{' '}
                        <Link href={`${siteUrl}/spothero-parking-guarantee/`}>
                            SpotHero Parking Guarantee
                        </Link>
                    </Text>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>);
};
export default SpotDetailsAccordion;
